import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "settings-printer mb-3"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", {
  class: "mb-1"
}, "Scan Bookings", -1);

var _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  class: "item-name"
}, "Scan bookings", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_row = _resolveComponent("el-row");

  var _component_el_form = _resolveComponent("el-form");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
    model: _ctx.formData,
    "label-position": "top",
    "label-width": "120px",
    "hide-required-asterisk": true,
    class: "setting-items"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_row, {
        class: "items-row"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_hoisted_3];
            }),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8,
            class: "d-flex fl-a-c"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_button, {
                type: _ctx.autoScanTickets ? 'primary' : 'default',
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.toggleStatus(true);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.auto")), 1)];
                }),
                _: 1
              }, 8, ["type"]), _createVNode(_component_el_button, {
                type: _ctx.autoScanTickets ? 'default' : 'primary',
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return _ctx.toggleStatus(false);
                })
              }, {
                default: _withCtx(function () {
                  return [_createTextVNode(_toDisplayString(_ctx.$t("button.manual")), 1)];
                }),
                _: 1
              }, 8, ["type"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["model"])]);
}